import { createGlobalStyle } from 'styled-components';

import './fonts';

// The body style is Paragraph/Large: the running text of the Updated Figma frames (Typography 13608:135688 and its siblings).
const BaseTypography = createGlobalStyle`
  body {
    font-family: ${({ theme }) => theme.typography.paragraphLarge.fontFamily}, sans-serif;
    font-size: ${({ theme }) => theme.typography.paragraphLarge.fontSize};
    line-height: ${({ theme }) => theme.typography.paragraphLarge.lineHeight};
    font-weight: ${({ theme }) => theme.typography.paragraphLarge.fontWeight};
    letter-spacing: ${({ theme }) => theme.typography.paragraphLarge.letterSpacing};
  }

  /* Form controls do not inherit the font from body. */
  button {
    font-family: ${({ theme }) => theme.typography.paragraphLarge.fontFamily}, sans-serif;
    font-weight: ${({ theme }) => theme.typography.paragraphLarge.fontWeight};
  }
`;

export default BaseTypography;
